// Explicit product-owner decisions: do not silently add pages or routes.
// This is audit metadata, not a declaration that every visible sentence on
// a separate static website is part of the multilingual patient app.
export const ENGLISH_ONLY_STANDALONE_PAGES = Object.freeze([
  { slug: 'for-hospitals', path: 'public/for-hospitals.html',
    title: 'For Hospitals', audience: 'organisations' },
  { slug: 'understanding-hospital-care', path: 'public/understanding-hospital-care.html',
    title: 'Understanding Hospital Care', audience: 'patients' },
]);
export const ENGLISH_ONLY_PATIENT_ROUTE_FILES = Object.freeze([
  'src/pages/WaitingForSurgeryJourney.jsx',
]);
export const ENGLISH_ONLY_FEATURES = Object.freeze([
  'Easy Read Journeys and draft Easy Read PDFs',
  'Waiting for Surgery / While You Wait for Surgery',
]);
// New standalone HTML must be explicitly reviewed and classified here.
